/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForAzureMca extends models.BaseCostProcessingMemory {
    constructor() {
        super();
        this.setDiscriminator("CostProcessingMemoryForAzureMca");
    }

    getFixupPrototypeFunction() { return CostProcessingMemoryForAzureMca.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForAzureMca>): CostProcessingMemoryForAzureMca {
        let obj = Object.assign(new CostProcessingMemoryForAzureMca(), model);
        CostProcessingMemoryForAzureMca.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForAzureMca>): CostProcessingMemoryForAzureMca {
        if (!model) return null;
        return CostProcessingMemoryForAzureMca.newInstance(<CostProcessingMemoryForAzureMca> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForAzureMca) {
        if (!obj) return;

        models.CostProcessingMemoryForAzureMca.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForAzureMca): boolean {
        if (models.BaseCostProcessingMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingMemoryForAzureMca.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.periods) {
            for (let val of this.periods) {
                models.CostProcessingPeriodMemoryForAzureMca.fixupPrototype(val);
            }
        }
    }

    /**
     * Processed billing periods
     */
    periods: Array<models.CostProcessingPeriodMemoryForAzureMca>;

}
